var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTilesViewIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 1.25C4 0.559375 3.44062 0 2.75 0H1.25C0.559375 0 0 0.559375 0 1.25V2.75C0 3.44062 0.559375 4 1.25 4H2.75C3.44062 4 4 3.44062 4 2.75V1.25ZM4 7.25C4 6.55937 3.44062 6 2.75 6H1.25C0.559375 6 0 6.55937 0 7.25V8.75C0 9.44063 0.559375 10 1.25 10H2.75C3.44062 10 4 9.44063 4 8.75V7.25ZM5 1.25V2.75C5 3.44062 5.55937 4 6.25 4H7.75C8.44063 4 9 3.44062 9 2.75V1.25C9 0.559375 8.44063 0 7.75 0H6.25C5.55937 0 5 0.559375 5 1.25ZM9 7.25C9 6.55937 8.44063 6 7.75 6H6.25C5.55937 6 5 6.55937 5 7.25V8.75C5 9.44063 5.55937 10 6.25 10H7.75C8.44063 10 9 9.44063 9 8.75V7.25ZM10 1.25V2.75C10 3.44062 10.5594 4 11.25 4H12.75C13.4406 4 14 3.44062 14 2.75V1.25C14 0.559375 13.4406 0 12.75 0H11.25C10.5594 0 10 0.559375 10 1.25ZM14 7.25C14 6.55937 13.4406 6 12.75 6H11.25C10.5594 6 10 6.55937 10 7.25V8.75C10 9.44063 10.5594 10 11.25 10H12.75C13.4406 10 14 9.44063 14 8.75V7.25Z",
    fill: "#0078d4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTilesViewIconActive);
export default __webpack_public_path__ + "static/media/tilesViewIconActive.f6766f43900ed829f64250eb5b34509a.svg";
export { ForwardRef as ReactComponent };